import Bank from "@/views/Banks/Bank.vue";
import Banks from "@/views/Banks/Banks.vue"
import Conciliation from "@/views/Banks/Conciliation.vue"
import ConciliationBanking from "@/views/Banks/ConciliationBanking.vue"
import ViewAccountBank from "@/views/Banks/ViewAccountBank.vue"
const bankRoute = {
    path: "/banks",
    name: "Bank",
    component: Bank,
    meta: {
        ACCOUNTING: true,
    },
    children: [
        {
            path: "list_banks",
            name: "Banks",
            component: Banks,
            meta: {
                ACCOUNTING: true,
            },
        },
        {
            path: "account_view/:id?",
            name: "ViewAccountBank",
            component: ViewAccountBank,
            meta: {
                ACCOUNTING: true,
            },
          },
        {
            path: "conciliation",
            name: "Conciliation",
            component: Conciliation,
            meta: {
                ACCOUNTING: true,
            },
        },

        {
            path: "new_conciliation",
            name: "ConciliationBanking",
            component: ConciliationBanking,
            meta: {
                ACCOUNTING: true,
            },
        },
    ],
}


export default bankRoute
